export const getUserId = state => state.userData.getIn(['userData', 'id']);
export const getUserName = state => state.userData.getIn(['userData', 'name']);
export const getOrganisationId = state => state.userData.getIn(['userData', 'organisationId']);
export const getUserLoaded = state => state.userData.get('userLoaded');



/** WEBPACK FOOTER **
 ** ./src/selectors/user-selectors.js
 **/